// @ts-check
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { decamelizeKeys } from 'humps';
import api from 'utils/api';
import { change, formValueSelector } from 'utils/reduxFormWrapper';
import Modal from 'shared/components/Modal';
import { SelectInput } from 'shared/containers/portal_layout/HForm';
import { CreateLocationForm } from './CreateLocationForm';

const CreatedLocation = ({ location, clearLocation }) => {
  return (
    <div className="level-left">
      <div className="level-item" style={{ fontSize: '1.5rem' }}>
        {location.organizationName} - {location.name}
      </div>
      <div className="level-item">
        <button onClick={clearLocation} className="button is-small is-danger is-outlined">
          Clear Location
        </button>
      </div>
    </div>
  );
};

const CreateLocationModal = ({ show, onHide, createLocation }) => {
  return (
    <Modal show={show} onHide={onHide}>
      <CreateLocationForm createLocation={createLocation} onSuccess={onHide} />
    </Modal>
  );
};

class _ExternalReferringLocationField extends Component {
  constructor(props) {
    super(props);
    this.state = { createLocationModalOpen: false };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.createNewLocation = this.createNewLocation.bind(this);
    this.clearCreatedLocation = this.clearCreatedLocation.bind(this);
  }

  openModal() {
    this.setState({ createLocationModalOpen: true });
  }

  closeModal() {
    this.setState({ createLocationModalOpen: false });
  }

  createNewLocation(formValues) {
    const { dispatch, form, selectedProvider } = this.props;
    const data = {
      location: decamelizeKeys(formValues.location || {}),
      organization: decamelizeKeys(formValues.organization || {}),
      provider_id: selectedProvider.id,
    };
    return api.post(`/agent_portal/api/locations`, data).then(resp => {
      const createdLocation = resp.data;
      dispatch(change(form, 'createdReferringLocation', createdLocation)); // This stores the createdLocation object into the main form's redux-form state
    });
  }

  clearCreatedLocation() {
    const { dispatch, form } = this.props;
    dispatch(change(form, 'createdReferringLocation', null));
  }
  render() {
    const { createdLocation, name, label, options } = this.props;
    return (
      <div className="field">
        <div className="control-group new-booking-form-group">
          <label className="control-label">{label}</label>
          <div className="controls">
            {!!createdLocation ? (
              <CreatedLocation
                location={createdLocation}
                clearLocation={this.clearCreatedLocation}
              />
            ) : (
              <div id="selectedReferringLocation-wrapper">
                <SelectInput
                  name={name}
                  placeholder={label}
                  options={options || []}
                  valueKey="id"
                  labelKey="name"
                />
                <div className="level-left" style={{ marginTop: '0.5rem' }}>
                  <p className="level-item is-size-7">
                    Couldn't find the practice your looking for?
                  </p>
                  <div className="level-item">
                    <button
                      type="button"
                      onClick={this.openModal}
                      className="button is-small is-primary is-outlined"
                    >
                      Enter new practice info
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <CreateLocationModal
          show={this.state.createLocationModalOpen}
          onHide={this.closeModal}
          createLocation={this.createNewLocation}
        />
      </div>
    );
  }
}

function mapStateToProps(_state, ownProps) {
  const selector = formValueSelector(ownProps.form);
  return state => {
    const createdReferringProvider = selector(state, 'createdReferringProvider');
    const externalReferringProvider = selector(state, 'externalReferringProvider');
    const selectedProvider = createdReferringProvider || externalReferringProvider;

    return {
      selectedProvider,
      createdLocation: selector(state, 'createdReferringLocation'),
    };
  };
}

const ExternalReferringLocationField = connect(mapStateToProps)(_ExternalReferringLocationField);

export { ExternalReferringLocationField };
